import React from 'react';
import { Form, Switch, Spin, Input, Tooltip, Select, Row, Col, Button, Upload, Icon, notification, InputNumber } from 'antd';
import { uploadAdsModalImage } from '../../modules/Api';
import { END_POINT } from '../../constants/config';

const FormItem = Form.Item;

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class TelegramMessage extends React.Component {
    constructor() {
        super();
        this.state = {
            type: null,
            text: null,
            media: null,
            link_title: null,
            link: null
        }
    }

    componentDidMount() {
        this.setState({
            type: null,
            text: null,
            media: null,
            link_title: null,
            link: null
        })
    }
    // componentWillReceiveProps(nextProps) {
    //     if (nextProps.initialData.image && this.state.image === null) {
    //         this.setState({ image: nextProps.initialData.image });
    //     }
    //     if (nextProps.initialData.limit && this.state.limit === null) {
    //         this.setState({ limit: nextProps.initialData.limit });
    //     }
    //     if (nextProps.initialData.repeat && this.state.repeat === null) {
    //         this.setState({ repeat: nextProps.initialData.repeat });
    //     }
    //     if (nextProps.initialData.delay && this.state.delay === null) {
    //         this.setState({ delay: nextProps.initialData.delay });
    //     }
    //     if (nextProps.initialData.link && this.state.link === "") {
    //         this.setState({ link: nextProps.initialData.link });
    //     }
    //     if (nextProps.initialData.alt && this.state.alt === "") {
    //         this.setState({ link: nextProps.initialData.alt });
    //     }
    //     if (nextProps.initialData.status && this.state.status === "") {
    //         this.setState({ status: nextProps.initialData.status });
    //     }
    // }
    handleSubmit = e => {

        e.preventDefault();
        if (this.submittedAt > Date.now() - 500) {
            return;
        }
        this.submittedAt = Date.now();

        this.props.form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }
            this.props.submit(Object.assign({}, fieldsValue, {
                media: this.state.media
            }));

        })
    }



    render() {
        let img = ""
        if (this.state.media != null) {
            img = <img src={`${this.state.media.includes('http') ? this.state.media : END_POINT + this.state.media}`}
                style={{ width: '50px', height: '50px', margin: '10px' }}
                alt="modal"
            />

        } else if (this.props.initialData.media != null) {
            img = <img src={`${this.props.initialData.media.includes('http') ? this.props.initialData.media : END_POINT + this.props.initialData.media}`}
                style={{ width: '50px', height: '50px', margin: '10px' }}
                alt="modal"
            />
        }
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        };
        const { getFieldDecorator, getFieldsError } = this.props.form;
        return (
            <div style={{ direction: 'rtl' }}>
                <Form onSubmit={this.handleSubmit}>
                    <Row>
                        <Col span={9} offset={1}>
                            <FormItem
                                {...formItemLayout}
                                label="بنر تبلیغاتی"
                                extra="اختیاری ، عکس یا فیلم حداکثر ۱۹ مگابایت"
                                colon={false}>
                                {getFieldDecorator('uploadMedia', {
                                    initialValue: this.props.initialData.media ? this.props.initialData.media : null,

                                    valuePropName: 'fileListMedia',
                                    getValueFromEvent: this.normFileMedia,
                                })(
                                    <Upload
                                        name="media"
                                        action=""
                                        customRequest={() => { }}
                                        onChange={f => { uploadAdsModalImage(f, (src) => { this.setState({ media: src }) }) }}
                                        listType="picture"
                                        showUploadList={false}>
                                        <Button>
                                            <Icon type="upload" /> انتخاب فایل
                                        </Button>
                                        <br />
                                        {img}
                                    </Upload>
                                )}
                            </FormItem>
                        </Col>

                        <Col span={11} offset={1}>


                            <FormItem
                                {...formItemLayout}
                                label={"لینک"}
                                colon={true} >
                                {getFieldDecorator('link', {
                                    initialValue: this.props.initialData.link ? this.props.initialData.link : null,
                                    rules: [{
                                        message: 'لینک دکمه ، اختیاری: ',
                                    }],
                                })(
                                    <Input />
                                )}
                            </FormItem>
                        </Col>


                    </Row>
            
                    <Row>
                        <Col span={6} offset={4}>
                            <FormItem
                                {...formItemLayout}
                                label="نوع پیام"
                                colon={false}>
                                {getFieldDecorator('type', {
                                    initialValue: this.props.initialData.type ? this.props.initialData.type : 'message',
                                    rules: [],
                                })(
                                    <Select placeholder="نوع تبلیغ" style={{ width: '200px' }}>
                                        <Select.Option value="message">متنی</Select.Option>
                                        <Select.Option value="photo">عکس</Select.Option>
                                        <Select.Option value="video">فیلم</Select.Option>

                                    </Select>
                                )}
                            </FormItem>
                        </Col>
                        <Col span={11} offset={1}>


                            <FormItem
                                {...formItemLayout}
                                label={"عنوان دکمه لینک"}
                                colon={true} >
                                {getFieldDecorator('link_title', {
                                    initialValue: this.props.initialData.link_title ? this.props.initialData.link_title : null,
                                    rules: [{
                                        message: 'عنوان دکمه لینک: ',
                                    }],
                                })(
                                    <Input />
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>

                        <Col span={11} offset={11}>


                            <FormItem
                                {...formItemLayout}
                                label="متن تبلیغ"
                                colon={false}>
                                {getFieldDecorator('text', {
                                    initialValue: this.props.initialData.text,
                                    rules: [
                                        {
                                            required: true
                                        }
                                    ],
                                })(
                                    <Input.TextArea />
                                )}
                            </FormItem>
                        </Col>
                    </Row>

                    <FormItem>
                        <div className="btn-container">
                            <Button
                                type="primary"
                                htmlType="submit"
                                disabled={hasErrors(getFieldsError()) || this.props.submitted}
                            >
                                {this.props.submitted ? 'منتظر بمانید' : ' ثبت'}
                            </Button>
                        </div>
                    </FormItem>
                </Form>
            </div>
        )
    }
}
TelegramMessage.defaultValue = {
    initialData: {}
}

export default Form.create()(TelegramMessage);



// WEBPACK FOOTER //
// ./src/containers/TelegramMessage/form.js